function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "bell",
  "data-name": "Path 54",
  d: "M66.051,81.74a7.97,7.97,0,0,1-2.829-6.1V72.327a8.327,8.327,0,0,0-16.654,0v3.317a7.972,7.972,0,0,1-2.841,6.1,2.082,2.082,0,0,0,1.354,3.664h5.443a4.461,4.461,0,0,0,8.742,0h5.443a2.081,2.081,0,0,0,1.342-3.672ZM54.9,87.2a2.68,2.68,0,0,1-2.523-1.784h5.046A2.68,2.68,0,0,1,54.9,87.2Zm9.814-3.569H45.082a.3.3,0,0,1-.3-.3.3.3,0,0,1,.107-.229,9.749,9.749,0,0,0,3.461-7.458V72.327a6.543,6.543,0,0,1,13.085,0v3.317A9.752,9.752,0,0,0,64.9,83.1a.294.294,0,0,1,.1.226A.3.3,0,0,1,64.709,83.628Z",
  transform: "translate(-43 -64)",
  fill: "#505e6c"
});

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.791,
    height: 24.98,
    viewBox: "0 0 23.791 24.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.6e839811.svg";
export { ForwardRef as ReactComponent };